module.exports = __webpack_public_path__ + "img/ic_edit_item.a944cbed.svg";